import { useRequiredContext } from "@redotech/react-util/context";
import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import conversionPopupUrl from "../assets/conversion-popup.webp?url";
import { OnboardingProps } from "../common";

export const ConversionOnboarding = memo(function ConversionOnboarding({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  const team = useRequiredContext(TeamContext);
  const navigate = useNavigate();

  const handleAction = () => {
    navigate(`/stores/${team._id}/conversion/welcome`);
    handleComplete();
  };

  return (
    <RedoFeatureNotificationCard
      actionText="Check it out"
      description="Explore how our new checkout personalization and optimization capabilities will work for you."
      image={conversionPopupUrl}
      onAction={handleAction}
      onDismiss={handleDismiss}
      title="Conversion"
    />
  );
});
